import React from 'react';
import * as icons from './Icon-list';

interface IconProps {
  ariaLabel?: undefined | string;
  name: boolean | string;
  iconText?: string;
}

export const Icon: React.FC<IconProps> = ({
  ariaLabel,
  name,
  iconText = ''
}) => {
  return (
    <span
      className="ads-icon"
      data-testid="ads-icon"
      style={{ display: 'flex' }}
      aria-label={ariaLabel}
    >
      {name === 'blank' && icons.blank()}
      {name === 'error' && icons.error()}
      {name === 'current' && icons.current()}
      {name === 'success' && icons.success()}
      {name === 'number' && icons.number(iconText)}
      {name === 'number-solid' && icons.numberSolid(iconText)}
    </span>
  );
};
